const color = {
  apple: "#A4DE02",
  darkapple: "#76BA1B",
  armygreen: "#729d39",
  darkgreen: "#36622b",
  lila: "#c3aed6",
  darklila: "#8675a9",
  darkpurple: "#45046a",
  whitesmoke: "#f5f5f5",
  greysmoke: "#bebebe",
  lightgrey: "#b0b0b0",
  grey: "#808080",
  darkgrey: "#696969",
  darkestgrey: "#494949",
};

export default color;
